<template lang="pug">
div
  div(v-if="!showThumb")
    el-row(v-for="item in infoItems", :key="item.id")
      el-col(:span='8')
        div.info-label {{ item.label }}
      el-col(:span='16')
        div.info-value {{ item.value }}
  div(v-if="showThumb")
    el-container
      el-aside(width='200px')
        img.thumbnail-large(:src="getMediumPreviewPath(file)", @click='playMedium(file)')
      el-main
        el-row(v-if="showThumb", v-for="item in infoItems", :key="item.id")
          el-col(:span='6')
            div.info-label {{ item.label }}
          el-col(:span='18')
            div.info-value {{ item.value }}
</template>

<script>
import textUtilsMixin from '../Common/textUtils.mixin'

export default {
  mixins: [textUtilsMixin],
  props: {
    'file': {
      required: true
    },
    'showThumb': {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getMediumPreviewPath (file) {
      console.log(file)
      return this.getPreviewPath(file)
    }
  },
  computed: {
    infoItems: function () {
      if (this.file === undefined || this.file === null || this.file.length === 0) {
        return []
      }

      let info = [
        { 'label': this.$t('Original file name:'), 'value': this.file.originalfilename },
        { 'label': this.$t('Original file hash:'), 'value': this.file.originalsha256 },
        { 'label': this.$t('Current file hash:'), 'value': this.file.currentsha256 },
        { 'label': this.$t('Original file size:'), 'value': this.humanFileSize(this.file.originalSize) },
        { 'label': this.$t('Current file size:'), 'value': this.humanFileSize(this.file.currentSize) },
        { 'label': this.$t('Original file MIME:'), 'value': this.file.originalMimeType },
        { 'label': this.$t('Width:'), 'value': this.file.originalWidthPixels + ' px' },
        { 'label': this.$t('Height:'), 'value': this.file.originalHeightPixels + ' px' }
      ]

      if (this.file.originalMimeType.indexOf('video') !== -1) {
        info.push({
          'label': this.$t('Duration:'),
          'value':
            this.$moment.duration(this.file.originalDurationMs).hours() + 'h:' +
            this.$moment.duration(this.file.originalDurationMs).minutes() + 'm:' +
            this.$moment.duration(this.file.originalDurationMs).seconds() + ',' +
            this.$moment.duration(this.file.originalDurationMs).milliseconds() + 's'
        })
      }

      info.push({ 'label': this.$t('Created at:'), 'value': this.humanTime(this.file.createdAt) })
      info.push({ 'label': this.$t('Updated at:'), 'value': this.humanTime(this.file.updatedAt) })

      return info
    }
  }
}
</script>
<style>
  .info-label, .info-value {
    font-size: 10px !important;
  }
  .thumbnail-large {
    max-width: 200px;
    max-height: 200px;
    margin-top: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/File/ShortInfo.vue